import React, { useEffect } from 'react';
import ToolCardInt from './ToolCardInt';
import './ToolsInt.css';
import BottomCardGroupInt from "../../BottomCardGroupInt/BottomCardGroupInt";
import { tutorDetailsToolsConfig, globalColors } from './tutorDetailsToolsConfig';

function ToolsInt(props) {
	const { data, bottomCard, campaignOrg, swipeActions } = props;
	const text = tutorDetailsToolsConfig.text || {};
	const toolsPageStyle = {
		'--tools-warm-text': globalColors.subheading || 'rgba(108, 39, 24, 1)',
		'--tools-card-border': globalColors.accent_color || '#E35C22',
		'--tools-card-background': globalColors.card_background || 'rgba(255, 241, 218, 0.7)',
	};
	useEffect(() => {
	}, []);
	return (
	<>
		<div className="page-content page-content-tool" {...swipeActions} style={toolsPageStyle}>
			<div className="tool-page-header">
				<h2>{text.heading || 'Tools to Get Ahead'}</h2>
				<p>{text.description || 'Use these tools to improve your store performance and earn upto 3x every month! '}</p>
			</div>
			{/* <BottomCardGroupInt bottomCard={bottomCard} campaignOrg={campaignOrg}></BottomCardGroupInt> */}
			<div className="tools-page-card-box">
				<ToolCardInt data={data} isTab />
			</div>
		</div>
	</>
	);
}

export default ToolsInt;
